<template>
  <div>
    <div class="top-header" :style="bg">
      <div class="game-info" @click="backToHome">
        <img class="game-logo" :src="logo" alt="game-logo" />
        <div class="header-safe">
          <em
            class="header-safe-icon iconfont icon-safe_icon g-gradient-btn"
          ></em>
          <p class="header-safe-tip">
            {{ letter.officialStore }} <br />
            {{ letter.headerSafeTip }}
          </p>
        </div>
      </div>
      <div class="right-info">
        <div
          v-show="![274, 2].includes(+gameId)"
          class="lang-switch btn-wrap j-select-lang"
          @click="toggleLangSelecter"
        >
          <em class="lang-switch-ico iconfont icon-lang"></em>
          <span class="lang-switch-text">{{ langList[lang] }}</span>
          <em class="lang-switch-ico-sanjiao"></em>
          <lang-selecter
            v-if="showLangSelecter"
            @closeSelecter="showLangSelecter = false"
            :langList="langList"
            :curLang="lang"
            :languages="letter"
            @selectLang="selectLang"
            @hideLangSelecter="showLangSelecter = false"
            style="z-index: 1002"
          ></lang-selecter>
        </div>
        <pwa-install-top v-if="showPwaInstallTop"></pwa-install-top>
      </div>
    </div>
    <div class="header-bottom">
      <em class="header-safe-icon iconfont icon-safe_icon g-gradient-btn"></em>
      <p class="header-safe-tip">
        {{ letter.officialStore }}
        {{ letter.headerSafeTip }}
      </p>
    </div>
  </div>
</template>

<script>
import PwaInstallTop from '@components/officialWebStore/PwaInstallTop.vue';
import LangSelecter from '@components/officialWebStore/LangSelecter.vue';
import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { LANGUAGE_LOCALSTORGE_NAME } from '@store/languages';
import {
  SWITCH_LANGUAGE,
  GET_PRODUCT_LIST,
  UPDATE_PRODUCT_LIST,
  SET_SHOW_CHANNEL_STATUS,
  UPDATE_LOADING
} from '@store/officialWebStore';

import { clickButton } from '@plugins/biPoint/_configWebstoreV2';
export default {
  data() {
    return {
      showLangSelecter: false
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      langList: state => state.langList,
      gameId: state => state.gameId
    }),
    ...mapGetters(['gameInfoConfig']),
    logo() {
      return (
        this.gameInfoConfig?.logo?.[this.lang] ||
        this.gameInfoConfig?.logo?.[this.defaultLang] ||
        ''
      );
    },
    defaultLang() {
      return this.gameInfoConfig?.defaultLang || '';
    },
    bg() {
      if (this.gameInfoConfig?.topBar) {
        return `background-image:url(${this.gameInfoConfig?.topBar})`;
      }
      return '';
    },
    showPwaInstallTop() {
      return !this.gameInfoConfig?.pwaAward?.open;
    }
  },
  methods: {
    backToHome() {
      this.$router.push({
        name: 'home'
      });
    },
    selectLang(val) {
      this.showLangSelecter = false;
      globalConfig.setLclStorageItem(LANGUAGE_LOCALSTORGE_NAME, val);
      this.$store.dispatch(SWITCH_LANGUAGE, val);
      this.$store.commit(UPDATE_LOADING, false);
      this.$store.commit(SET_SHOW_CHANNEL_STATUS, false);
      if (this.$store.state.serverId && this.$store.state.roleId) {
        this.$store.dispatch(GET_PRODUCT_LIST);
        this.$store.commit(UPDATE_PRODUCT_LIST, []);
      }
      window?.globalUpdateCommonParamsInfo?.({
        language: val
      });

      clickButton({
        btnName: 'select_language',
        locationKey: this.$route.meta.pageName
      });
    },
    toggleLangSelecter() {
      clickButton({
        btnName: 'select_language_btn',
        locationKey: this.$route.meta.pageName
      });
      this.showLangSelecter = !this.showLangSelecter;
    }
  },
  components: {
    PwaInstallTop,
    LangSelecter
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.top-header {
  display: flex;
  justify-content: space-between;
  height: 106px;
  width: 100%;
  font-size: 22px;
  background-position: center center;
  padding: 0 42px;
  box-sizing: border-box;
  .game-info {
    display: flex;
    align-items: center;
    .game-logo {
      width: 66px;
      border-radius: 9px;
      cursor: pointer;
    }
  }
  .right-info {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
  }
  .header-safe {
    margin-left: 20px;
    padding: 12px 17px 15px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    justify-self: center;
    align-items: center;
    display: none;

    .header-safe-icon {
      overflow: hidden;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-image: linear-gradient(
        to right,
        var(--gradientBtnLeft, #3b90f3),
        var(--gradientBtnRight, #8ec2ff)
      );
      font-size: 37px;
    }
    .header-safe-tip {
      margin-left: 10px;
      font-size: 16px;
      color: #ffffff;
      line-height: 17px;
    }
  }
  .btn-wrap {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    background: #fff;
    border-radius: 30px;
    padding: 0 20px;
    height: 45px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .lang-switch {
    &-ico {
      display: inline-block;
      margin-right: 10px;
      font-size: 23px;
    }
    &-ico-sanjiao {
      display: inline-block;
      width: 16px;
      height: 9px;
      background: url($tmslgImg + 'lang-sanjiao.png') no-repeat;
      margin-left: 10px;
    }
    .lang-switch-text {
      ::v-deep .select {
        padding: 0;
      }
    }
  }
}

.header-bottom {
  background-color: #ffffff;
  padding: 12px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 0 0 20px 20px;
  box-shadow: 0px 10px 10px 0 #e7e7e7;

  .header-safe-icon {
    overflow: hidden;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-image: linear-gradient(
      to right,
      var(--gradientBtnLeft, #3b90f3),
      var(--gradientBtnRight, #8ec2ff)
    );
    font-size: 32px;
  }
  .header-safe-tip {
    margin-left: 10px;
    font-size: 22px;
    color: #333333;
  }
}

@media screen and (orientation: landscape) {
  .top-header {
    height: 106px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    .game-info {
      .game-logo {
        width: 66px;
      }
    }
    .lang-switch {
      position: relative;
      font-size: 16px;
      &-ico {
        font-size: 22px;
      }
    }
    .header-safe {
      display: flex;
    }
  }
  .header-bottom {
    display: none;
  }
}
</style>
